// Shared constants for Community Stays (used by the Travel Stays panel + Stay detail page).
export const ACCOM_LABEL = { private_room: "Private room", shared_room: "Shared room", whole_place: "Whole place" };
export const FOOD_LABEL = { none: "No meals", breakfast: "Breakfast", all_meals: "All meals" };

export const AMENITIES = {
  wifi: "Wi‑Fi",
  ac: "Air conditioning",
  fan: "Fan",
  heater: "Room heater",
  cooler: "Cooler",
  hot_water: "Hot water",
  geyser: "Geyser",
  parking: "Parking",
  kitchen: "Kitchen",
  tv: "TV",
  washing_machine: "Washing machine",
  fridge: "Refrigerator",
  power_backup: "Power backup",
  workspace: "Workspace",
  balcony: "Balcony",
  garden: "Garden",
  pets_ok: "Pets allowed",
  wheelchair: "Wheelchair access",
};

export const STAY_STATUS = {
  requested: { c: "#f59e0b", label: "Requested" },
  accepted: { c: "#3b82f6", label: "Accepted · awaiting payment" },
  paid: { c: "#22c55e", label: "Booked" },
  completed: { c: "#84cc16", label: "Completed" },
  declined: { c: "#ef4444", label: "Declined" },
  cancelled: { c: "#ef4444", label: "Cancelled" },
};

// Upcoming vs past classification for a guest's bookings.
export const isUpcomingStay = (b) => {
  if (["requested", "accepted", "paid"].includes(b.status)) {
    if (!b.check_in) return true;
    try { return new Date(b.check_in) >= new Date(new Date().toDateString()); } catch { return true; }
  }
  return false;
};
